//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'GlobalNavigationBar',
  props: {
    selected: {
      type: String,
      default: ''
    },
    filters: {
      type: Array,
      required: true
    },
    navigateTo: {
      type: Function,
      required: true
    }
  },
  methods: {
    selectedStyle(_ref) {
      let {
        tag,
        color
      } = _ref;

      if (this.selected === tag) {
        return {
          '--bg-color': color || 'hsla(60, 1%, 23%, 1)'
        };
      }

      return {
        '--bg-color': 'hsla(60, 1%, 23%, 1)'
      };
    },

    tracking(category, action, label) {
      return {
        data: {
          event_category: category,
          event_action: action,
          event_label: label
        }
      };
    }

  }
};